import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from '@mui/material';


interface AuthFlowSelectProps {
    handleFlowChange: (event: SelectChangeEvent<any>) => void;
    formType: "login" | "signup";
}

const approveFlow = {
    name: 'Approve (Frictionless)',
    email: 'approve@forter.com',
    password: 'Approve123',
    showOn: "all",
};

const declineFlow = {
    name: 'Decline',
    email: 'decline@forter.com',
    password: 'Decline123',
    showOn: "all",
};

const challengeFlow = {
    name: 'Challenge (captcha)',
    email: 'challenge@forter.com',
    password: 'Challen123',
    showOn: "login",
};

const proxyFlow = {
    name: 'Challenge (geolocation)',
    email: 'proxy@forter.com',
    password: 'Proxyman123',
    showOn: "login",
};

const suspiciousFlow = {
    name: 'Suspicious (force logout)',
    email: 'suspicious@forter.com',
    password: 'Suspi123',
    showOn: "login",
};
const flows = { approveFlow, declineFlow, challengeFlow, proxyFlow, suspiciousFlow };

const AuthFlowSelect: React.FC<AuthFlowSelectProps> = ({ handleFlowChange, formType }) => {
    const filteredFlows = Object.entries(flows).filter(([_, value]) => 
        value.showOn === "all" || value.showOn === formType
    );
    return (
        <FormControl fullWidth>
            <InputLabel id="auth-flow-select-label">Auth flow</InputLabel>
            <Select
                labelId="auth-flow-select-label"
                id="auth-flow-select"
                label="Auth flow"
                onChange={handleFlowChange}
            >
                {filteredFlows.map(([key, value]) => (
                    <MenuItem key={key} value={value as any}>
                        {value.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default AuthFlowSelect;